import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@Component({
  selector: 'rappider-ai-input-modal',
  standalone: true,
  imports: [
    FormsModule,
    NzModalModule,
    NzSpinModule
  ],
  templateUrl: './ai-input-modal.component.html',
  styleUrls: ['./ai-input-modal.component.scss'],
})
export class RappiderAiInputModalComponent implements OnInit, OnChanges, OnDestroy {

  @Input() aiDialogId?: string = '';
  @Input() showSaveConfirmation? = false;
  @Input() aiInProgress? = false;
  @Input() aiInputText?: string;
  @Input() confirmationText?: string;
  @Input() confirmButtonTitle?: string = 'Save';
  @Input() modalTitle?: string = 'Ask Rapider AI';
  @Input() hasModalMask?: boolean = true;

  @Output() textSubmitted = new EventEmitter<string>();


  ngOnInit(): void {
    console.log('AI Input Modal Initialized');
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('AI Input Modal Changes Detected');
  }

  ngOnDestroy(): void {
    console.log('AI Input Modal Destroyed');
  }

  onConfirmClicked(): void {
    this.showSaveConfirmation = false;
    this.handleConfirmation();
  }

  onDiscardConfirmClicked(): void {
    this.showSaveConfirmation = false;
  }

  handleOkClicked(): void {
    console.log('OK clicked', this.aiInputText);
    this.textSubmitted.emit(this.aiInputText);
  }

  handleConfirmation(): void {
    console.log('Confirmation handled');
  }

}
